import { Button, Tooltip } from "@material-tailwind/react";
import { useState } from "react";
import DataTable from "react-data-table-component";
import { TbFileInvoice } from "react-icons/tb";

const InvoiceComponent = (props) => {
  // STATE VARIABLES
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [ordersList, setOrdersList] = useState([]);
  const [totalDocs, setTotalDocs] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  /* ORDER COLUMNS */
  const columns = [
    {
      name: "Payment ID",
      width: "10vh",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          {row.orderID}
        </span>
      ),
    },
    {
      name: "Invoice Date",
      width: "25vh",
      selector: (row) => (
        <span className="text-sm font-proxima-bold text-black">
          {row.invoiceDate}
        </span>
      ),
    },
    {
      name: "Amount",
      selector: (row) => (
        <span className="text-sm font-proxima-semibold text-black text-opacity-60">
          ₹{parseFloat(row.amount).toLocaleString("en-IN")}
        </span>
      ),
    },
    {
      name: "Status",
      width: "15vh",
      selector: (row) =>
        row.paymentStatus === "Cash on Delivery" ? (
          <span className="text-sm font-proxima-semibold text-orange-800">
            {row.paymentStatus}
          </span>
        ) : (
          <span className="text-sm font-proxima-semibold text-green-500">
            {row.paymentStatus}
          </span>
        ),
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="flex items-center">
          <Tooltip
            content="View invoice"
            className="text-sm font-proxima-semibold"
          >
            <Button className="p-2 rounded-full shadow-none hover:shadow-none bg-transparent hover:bg-black hover:bg-opacity-5">
              <TbFileInvoice className="w-5 h-5 text-greyText" />
            </Button>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div className="p-5 xl:p-10 lg:p-10">
    <h2 className="text-xl font-proxima-bold text-black">
      Previous Invoices
    </h2>
    <h3 className="text-base font-proxima-regular text-greyText">
      Manage invoices of this customer
    </h3>

    {/* ORDERS TABLE */}
    <div className="mt-5">
      <DataTable
        className="data-table"
        data={ordersList}
        columns={columns}
        responsive
        pagination
        paginationTotalRows={15}
        noDataComponent={
          <div className="w-full bg-[#F5F5F5] bg-opacity-50 rounded-md border border-authBorder py-5">
            <p className="text-sm font-proxima-semibold text-black text-center">
              There are no orders to display.
            </p>
          </div>
        }
      />
    </div>
  </div>
  );
};

export default InvoiceComponent;
